import { SettingToggle } from 'components/Settings';
import { useTranslation } from 'react-i18next';
import { Paper } from 'shell/components';

export const AssignmentSettingToggleCard = ({ title, description, checked, disabled, restricted, onChange }) => {
    const { t } = useTranslation('assignment');
    return (
        <Paper variant={'outlined'} sx={{ p: 5, borderRadius: 4 }}>
            <SettingToggle
                label={title}
                description={description}
                checked={checked}
                disabled={disabled || restricted}
                tooltip={
                    restricted
                        ? {
                              component: t(
                                  'institution-disabled',
                                  'Disabled by your institution. Request access or contact IT.'
                              ),
                          }
                        : undefined
                }
                onChange={onChange}
                labelTextProps={{ variant: 'p1', weight: 'medium' }}
            />
        </Paper>
    );
};
